<ng-template ixPageHeader>
  <ix-page-title-header>
    <ix-manage-configuration-menu></ix-manage-configuration-menu>
  </ix-page-title-header>
</ng-template>

<div class="cards">
  <ix-support-card></ix-support-card>
  <ix-gui-card></ix-gui-card>
  <ix-localization-card></ix-localization-card>
  <ix-ntp-server-card></ix-ntp-server-card>
  <ix-email-card></ix-email-card>
</div>
